// @flow
import * as React from 'react';
import Icon, { type IconName } from '@ta/core-ui.icon';
import styles from './ToastItem.css';

type Props = {|
  /** optional icon name that will appear to the left of the message node */
  iconName?: IconName,
  /** optional node to show on the right side of the toast */
  cta?: React.Node,
  /** Primary content for the toast */
  children: React.Node,
|};

/**
 * Represents a single toast notification
 */
const ToastItem = ({ iconName, cta, children }: Props) => (
  <div className={styles.toast_wrap}>
    <div className={styles.toast}>
      <div className={styles.toast_text}>
        {iconName && (
          <div className={styles.toast_icon}>
            <Icon name={iconName} />
          </div>
        )}
        <div className={styles.node_wrap}>{children}</div>
      </div>
      {cta && <div className={styles.toast_action}>{cta}</div>}
    </div>
  </div>
);

export default ToastItem;
